import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle, Mail, ArrowRight } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
export function ContactCTA() {
  return <section className="py-20 bg-white relative" data-id="element-569">
      <div className="max-w-4xl mx-auto px-6 relative z-10" data-id="element-570">
        <SectionHeading title="Pentru o sesiune gratuită de evaluare 1 la 1" data-id="element-571" />

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="bg-brand-cream rounded-[32px] p-8 md:p-12 shadow-warm border border-brand-gold/10" data-id="element-572">
          <p className="text-lg text-brand-textSec mb-8 text-center" data-id="element-573">
            Cel mai rapid mod este să mă contactezi direct pe WhatsApp. În
            mesaj, te rog să incluzi:
          </p>

          <div className="space-y-4 mb-10 max-w-2xl mx-auto" data-id="element-574">
            <div className="flex items-start gap-4 bg-white p-4 rounded-2xl shadow-sm" data-id="element-575">
              <div className="w-8 h-8 rounded-full bg-brand-gold/10 text-brand-gold flex items-center justify-center font-bold shrink-0" data-id="element-576">
                1
              </div>
              <p className="text-brand-text font-medium pt-1" data-id="element-577">
                Numele tău complet
              </p>
            </div>
            <div className="flex items-start gap-4 bg-white p-4 rounded-2xl shadow-sm" data-id="element-578">
              <div className="w-8 h-8 rounded-full bg-brand-gold/10 text-brand-gold flex items-center justify-center font-bold shrink-0" data-id="element-579">
                2
              </div>
              <p className="text-brand-text font-medium pt-1" data-id="element-580">
                O propoziție scurtă despre ce te preocupă (blocaje emoționale,
                relația cu banii, stres, lipsă de încredere, dorința de
                schimbare)
              </p>
            </div>
            <div className="flex items-start gap-4 bg-white p-4 rounded-2xl shadow-sm" data-id="element-581">
              <div className="w-8 h-8 rounded-full bg-brand-gold/10 text-brand-gold flex items-center justify-center font-bold shrink-0" data-id="element-582">
                3
              </div>
              <p className="text-brand-text font-medium pt-1" data-id="element-583">
                Cum ai aflat despre Academia de Abundență
              </p>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-6" data-id="element-584">
            <a href="https://wa.me/40726042604?text=Bun%C4%83.%0A%0ASunt%20interesat%2F%C4%83%20de%20sesiunea%20CADOU%20de%20Claritate%20de%2030%20de%20minute.%0A%0AVreau%20s%C4%83%20aflu%20mai%20multe%20detalii%20despre%20programele%20tale.%0A%0AMul%C8%9Bumesc." target="_top" className="group inline-flex items-center justify-center gap-3 bg-[#25D366] text-white font-heading font-semibold text-lg px-8 py-4 rounded-full hover:bg-[#20BD5A] transition-all duration-300 shadow-warm hover:shadow-warm-hover hover:-translate-y-1 w-full sm:w-auto text-center" data-id="element-585">
              <MessageCircle className="w-5 h-5" data-id="element-586" />
              Scrie-mi pe WhatsApp
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-587" />
            </a>
            <a href="mailto:academia.abundentei365@gmail.com" className="group inline-flex items-center justify-center gap-3 bg-brand-purple text-white font-heading font-semibold text-lg px-8 py-4 rounded-full hover:bg-brand-purple/90 transition-all duration-300 shadow-warm hover:shadow-warm-hover hover:-translate-y-1 w-full sm:w-auto text-center" data-id="element-588">
              <Mail className="w-5 h-5" data-id="element-589" />
              Trimite un Email
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-590" />
            </a>
          </div>

          <p className="text-sm font-subtitle italic text-brand-textSec text-center" data-id="element-591">
            Apăsând pe butoane se va deschide aplicația de WhatsApp sau email
            direct pe telefonul tău.
          </p>
        </motion.div>
      </div>
    </section>;
}